import React, { useMemo, useState } from "react";
import { Sparkles } from "lucide-react";
import { StaggerGrid, StaggerItem } from "../Motion";
import { SkeletonGrid } from "../LoadingSkeleton";
import { EmptyState } from "../DataState";
import { DiscoverCard } from "./DiscoverCard";

// "Explore by" tabs — every metric here already exists on the real
// LONGVIEW score object returned by /companies/:ticker. Sorting/filtering
// happens entirely client-side over already-fetched real data.
const TABS = [
  { key: "quality", label: "Business Quality", metric: "business_quality", dir: "desc" },
  { key: "health", label: "Financial Health", metric: "financial_health", dir: "desc" },
  { key: "growth", label: "Growth", metric: "growth", dir: "desc" },
  { key: "valuation", label: "Valuation", metric: "valuation", dir: "desc" },
  { key: "risk", label: "Lower Risk", metric: "risk", dir: "asc" },
];

export const FeaturedDiscoveries = ({ companies }) => {
  const [tab, setTab] = useState("quality");
  const active = TABS.find((t) => t.key === tab);

  const sorted = useMemo(() => {
    if (!companies) return [];
    return companies
      .filter((c) => c.scores?.[active.metric] != null)
      .sort((a, b) => (active.dir === "asc" ? a.scores[active.metric] - b.scores[active.metric] : b.scores[active.metric] - a.scores[active.metric]))
      .slice(0, 6);
  }, [companies, active]);

  if (companies === null) return <SkeletonGrid count={6} blockClassName="h-56" />;

  return (
    <div>
      <div data-testid="discover-explore-tabs" className="mb-4 flex flex-wrap items-center gap-2">
        {TABS.map((t) => (
          <button
            key={t.key}
            data-testid={`discover-explore-${t.key}`}
            onClick={() => setTab(t.key)}
            className={`lv-press rounded-md border px-3 py-1.5 font-mono text-xs transition-colors ${
              tab === t.key ? "border-amber-500/40 bg-amber-500/10 text-amber-300" : "border-white/[0.08] text-zinc-400 hover:border-white/20 hover:text-zinc-200"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {sorted.length === 0 ? (
        <EmptyState icon={Sparkles} title="Not enough scored data yet" detail="LONGVIEW couldn't find enough companies with this metric to build a meaningful list." />
      ) : (
        <StaggerGrid data-testid="discover-featured-grid" className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {sorted.map((c) => <StaggerItem key={c.ticker}><DiscoverCard c={c} primaryMetric={active.metric} /></StaggerItem>)}
        </StaggerGrid>
      )}
    </div>
  );
};
